module.exports = __webpack_public_path__ + "static/media/wettability_icon.68b913cd.png";